"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styles = require("../StripeCardForm/styles");

var _templateObject;

var Container = (0, _styledComponents.default)(_styles.PaymentFormContainer)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  ", "\n  img {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n  }\n"])), function (_ref) {
  var isSelected = _ref.isSelected;
  return isSelected && "border-color: #8A6CAA;\n  background: #F7F7FC;";
});
exports.Container = Container;